/* eslint-disable no-console */
import axios, { AxiosError } from "axios";
import { axiosRequestConfig, ProfileUrl } from "../apiConstants";

export interface ILanguagesResponse {
  id: number;
  language: string;
}

const getLanguages = async (jwt: string) => {
  try {
    return await axios.get<ILanguagesResponse>(
      `${ProfileUrl}/Languages`,
      axiosRequestConfig(jwt)
    );
  } catch (err) {
    console.error("error: ", err);
    return (err as AxiosError).response;
  }
};

export default getLanguages;
